export default __webpack_public_path__ + "static/media/04_stats.1e600413.svg";